import { User as UseUser } from './useUser.ts';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext.tsx';

export type User = UseUser;

export function useAuth() {
  // Return the entire context object, which now includes user, isLoading, isError, and error
  const context = useContext(AuthContext);
  // Optional: Add a check if the hook is used outside the provider
  // if (!context) {
  //   throw new Error('useAuth must be used within an AuthProvider');
  // }
  return context; // Returns { user, isLoading, isError, error }
}
